import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Icon } from 'semantic-ui-react';
import i18next from 'i18next';

import { DataGrid } from '../../common';
import SideEditor from '../../general/SideEditor';
import CompanyEditor from './CompanyEditor';
import { setEditedEntity, confirmDelete, deleteCompany } from '../../../actions';
import { hasBudgetsPermission } from '../../../helpers/permissions';

class Companies extends Component {

    constructor(props) {
        super(props);

        this.renderCreationButton = this.renderCreationButton.bind(this);
    }

    handleDelete = (company) => {
        this.props.confirmDelete(company.name, () => this.props.deleteCompany(company.id));
    }

    renderCreationButton() {
        if (!hasBudgetsPermission('operation')) return null;

        const { setEditedEntity } = this.props;

        return (
            <Button
                icon
                labelPosition='left'
                floated="right"
                primary
                onClick={() => setEditedEntity('company')}
            >
                <Icon name='add' /> {i18next.t('create')}
            </Button>
        );
    }

    render() {
        const { history, companies, onEdit, setEditedEntity } = this.props;

        const columns = [{
            Header: '#',
            accessor: 'id',
            maxWidth: 50,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' }
        }, {
            Header: i18next.t('name'),
            accessor: 'name',
            filterable: true
        }, {
            Header: i18next.t('address'),
            accessor: 'address',
            filterable: true
        }, {
            id: 'actions',
            Header: i18next.t('actions'),
            minWidth: 142,
            maxWidth: 142,
            sortable: false,
            filterable: false,
            Cell: row => {
                const company = row.original;

                return (
                    <div>
                        <Button
                            circular
                            size='tiny'
                            icon='find'
                            primary
                            onClick={() => history.push(`/company/${company.id}`)}
                        />
                        {hasBudgetsPermission('operation') && <Button circular size='tiny' icon='write' basic onClick={() => setEditedEntity('company', company)} />}
                        {hasBudgetsPermission('operation') && <Button circular size='tiny' icon='trash' negative onClick={() => this.handleDelete(company)} />}
                    </div>
                );
            }
        }];

        return (
            <div style={{ padding: 10 }}>
                <SideEditor
                    title={i18next.t('company')}
                    visible={onEdit}
                    handleClose={() => setEditedEntity(null)}
                >
                    <CompanyEditor />
                </SideEditor>

                <DataGrid
                    data={companies}
                    columns={columns}
                    getTrGroupProps={(state, rowInfo, column) => {
                        return {};
                    }}
                    extraActions={this.renderCreationButton()}
                    paginated
                   
                />

            </div>
        );
    }
}

Companies.propTypes = {
    companies: PropTypes.array,
    onEdit: PropTypes.bool,
    setEditedEntity: PropTypes.func,
    confirmDelete: PropTypes.func,
    deleteCompany: PropTypes.func,
    history: PropTypes.object,
    
};

const mapStateToProps = (state, ownProps) => {
    const { companies } = state.budgetsApp;
    const onEdit = state.editor.type === 'company';

    return { companies, onEdit };
};

export default connect(mapStateToProps,
    { setEditedEntity, confirmDelete, deleteCompany })(Companies);
